export enum MouseButton {
  Left = 0,
  Middle = 1,
  Right = 2
}
